
/**
* 
* Radiobox Field
* 
*/

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Label, FormGroup } from 'reactstrap'

// import {  Input } from 'reactstrap'

function QuestionRadioboxField(props) {
    const { name, label, value, options, onChange } = props

    const [state, setState] = useState([])
    const [oninit, setoninit] = useState('1')
    const string = value
    console.log(string,value,string===value)
    var arr = string.split(',')
    if (oninit == '1'&&value) {
        // console.log("oncee",arr,state)
        arr.forEach((element, index) => {
            state[index] = element
            // console.log(element,index)
        })
        setoninit('2')
    }
    // console.log(arr, typeof arr, typeof Object.values(arr), Object.values(arr), value)

    const handleOnChange = (e, i) => {
        let val = state
        val[i] ? val[i] = undefined : val[i] = e
        // arr[i]?arr[i]=undefined:arr[i]=e
        // console.log(value, val, "sri", state[1], state[0])
        setState(val)
        // console.log(val)
        // console.log(state.toString())


    }
    return (
        <React.Fragment>
            <FormGroup className="mb-3">
                <Label htmlFor={name}>{label}
                    {/* {required ? <span style={{ color: 'red' }}>*</span> : null} */}
                </Label>
                <div style={{ display: 'flex', width: '100%', flexWrap: 'wrap' }}>
                    {/* array.forEach(element => {
                        
                    }); */}
                    {(options || []).map((opt, index) => {
                        // console.log(opt)
                        return (<div key={index} className="form-check p-0" style={{ marginRight: '15px' }}>

                            <input
                                style={{"vertical-align":"middle",margin: '5px'}}
                                type="checkbox"
                                id={opt.label}
                                name={opt.label}
                                checked={state[index] ? true : false}
                                onChange={() => {
                                    onChange({ target: { value: state.toString() } })
                                    console.log(state.toString())
                                    setTimeout(() => {
                                        
                                    onChange({ target: { value: state.toString() } })
                                    }, 1000)
                                    console.log(state.toString())

                                    handleOnChange(opt.label, index)
                                }}
                            // value={state}
                            />
                            <label htmlFor={opt.label}>{opt.value}</label>


                        </div>)
                    })}
                </div>
            </FormGroup>
        </React.Fragment>
    )
}

QuestionRadioboxField.propTypes = {
    t: PropTypes.any,
    onChange: PropTypes.func,
    isInvalid: PropTypes.any,
    value: PropTypes.any,
    name: PropTypes.any,
    label: PropTypes.any,
    options: PropTypes.array
}

export default QuestionRadioboxField